import { FC } from 'react'
import { DistributionExpressDraft } from '../types/types'

interface ExpressDistributionProps {
  express: DistributionExpressDraft
}

const ExpressDistribution: FC<ExpressDistributionProps> = ({ express }) => {
  return (
    <div>
      <h4>Express Distribution</h4>
      <p>
        <strong>Express website name:</strong> {express.websiteName}
      </p>
    </div>
  )
}

export default ExpressDistribution
